"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumberInput = void 0;
/**
 * 數字欄位：輸入時就去掉不合法的字元（整數只留數字；小數只留數字和第一個小數點）
 *
 * 用法：`<Input {...amountInput.bind(register('amount', rules))} />`
 * 不要寫 `onChange={amountInput.handleChange}` 蓋掉 react-hook-form 的 onChange：
 * 值會等失焦才同步進表單，在欄位裡直接按 Enter 送出會誤報「必填」（R35）
 */
const useNumberInput = (type = 'decimal') => {
    const pattern = type === 'integer' ? /^\d*$/ : /^\d*\.?\d*$/;
    /** 自己組 onChange 時要再呼叫 register 的 onChange（見 PM MilestoneDialog） */
    const handleChange = (e) => {
        const value = e.target.value;
        if (pattern.test(value))
            return;
        const digitsAndDots = value.replace(type === 'integer' ? /\D/g : /[^\d.]/g, '');
        const firstDot = digitsAndDots.indexOf('.');
        e.target.value = firstDot === -1
            ? digitsAndDots
            : digitsAndDots.slice(0, firstDot + 1) + digitsAndDots.slice(firstDot + 1).replace(/\./g, '');
    };
    /** 包住 register() 的結果：先過濾字元，再交給 react-hook-form（型別用結構比對，共用套件不依賴 react-hook-form） */
    const bind = (registration) => ({
        ...registration,
        onChange: (e) => {
            handleChange(e);
            return registration.onChange(e);
        },
    });
    /** react-hook-form 驗證規則（貼上等繞過 onChange 的輸入，送出時再擋一次） */
    const validationRules = {
        pattern: { value: pattern, message: 'Please enter a valid number' },
    };
    return { handleChange, bind, validationRules };
};
exports.useNumberInput = useNumberInput;
